export default {
  methods: {
    getStatutEC(value) {
      return value === true ? 'Oui' : 'Non';
    },
  },
};
